import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { clone, clearBindings } from '../util/Utility.js';

export default class EncouragementView extends Component {

  fetchObjects(limit, callback) {
    callback(clone(window.encouragement))
  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {
    return (<center>
      <h3>Encouragement Just For You </h3>
      <p>These are submitted by members of the congregation to you personally</p>
      <PanelHolder type="encouragement" fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/encouragement/EncouragementView.js
 **/